import { render, staticRenderFns } from "./AreaPlantadaSojaParaguai20252026.vue?vue&type=template&id=18be546c&scoped=true&lang=pug"
import script from "./AreaPlantadaSojaParaguai20252026.vue?vue&type=script&lang=js"
export * from "./AreaPlantadaSojaParaguai20252026.vue?vue&type=script&lang=js"
import style0 from "./AreaPlantadaSojaParaguai20252026.vue?vue&type=style&index=0&id=18be546c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18be546c",
  null
  
)

export default component.exports